import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { NgbDropdownConfig, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { switchMap } from 'rxjs/operators';

import { Auth0Service } from '../../core/oauth0';
import { CurrentUserService, TenantsService } from '../../core/services';
import { ROUTER_LINKS } from '../../interfaces/router-links.enum';
import { SupportRequestService } from '../support-request/support-request.service';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';

@Component({
  selector: 'app-profile-header',
  templateUrl: './profile-header.component.html',
  styleUrl: './profile-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbDropdownModule, RouterLink, RouterLinkActive, TranslocoDirective, UserAvatarComponent],
  providers: [SupportRequestService]
})
export class ProfileHeaderComponent {
  readonly #dr = inject(DestroyRef);
  readonly #auth = inject(Auth0Service);
  readonly #currentUser = inject(CurrentUserService);
  readonly #router = inject(Router);
  readonly #config = inject(NgbDropdownConfig);
  readonly #supportRequest = inject(SupportRequestService);
  readonly #tenantService = inject(TenantsService);

  public readonly user = toSignal(this.#currentUser.getLiveProfile$(), { initialValue: null });

  readonly #tenant = toSignal(this.#tenantService.getCurrent(), { initialValue: null });
  protected readonly isEnterprise = computed(
    () => this.#tenant()?.enterprise && !!this.#tenant()?.contentfulSpaceAlias
  );

  constructor() {
    const config = this.#config;

    config.placement = ['bottom-left', 'top-right'];
  }

  public openSupportRequest(): void {
    this.#supportRequest.open().pipe(takeUntilDestroyed(this.#dr)).subscribe();
  }

  public logout(): void {
    this.#auth
      .logout()
      .pipe(
        switchMap(() => this.#router.navigate([ROUTER_LINKS.LOGOUT])),
        takeUntilDestroyed(this.#dr)
      )
      .subscribe();
  }
}
